export const US_PHONE_MESSAGE = 'Enter a complete US phone number, like (312) 555-0148.';

export function isCompleteUsPhone(value) {
  const text = (value ?? '').toString().trim();
  if (!text) return true;
  if (!/^\+?[0-9 ().-]+$/.test(text)) return false;

  let digits = text.replace(/\D/g, '');
  if (digits.length === 11 && digits[0] === '1') digits = digits.slice(1);

  return digits.length === 10 && digits[0] >= '2' && digits[3] >= '2';
}
